import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-665cfea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "truncate text-sm" }

import { ComputedRef, Ref, computed, ref, watch } from 'vue';
import { RouteLocationNamedRaw, Router, useLink, useRouter } from 'vue-router';
import { useLocationStore } from '@/stores/location';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySidemenuSubItem',
  props: {
  title: {
    type: String,
    required: true,
  },
  mainCategory: {
    type: Number,
    required: true,
  },
  subCategory: {
    type: Number,
    required: true,
  },
},
  emits: {
  effect: null,
},
  setup(__props, { emit }) {

const props = __props;





const categoryItemListRoute: RouteLocationNamedRaw = {
  name: 'list',
  params: {
    mainCategory: props.mainCategory,
    subCategory: props.subCategory,
  },
};

const locationStore = useLocationStore();
const router: Router = useRouter();
const { isActive: categoryItemListActiveRoute } = useLink({ to: categoryItemListRoute });

const itemListActiveRoute: Ref<boolean> = ref(false);

const isActive: ComputedRef<boolean> = computed((): boolean => {
  return categoryItemListActiveRoute.value || itemListActiveRoute.value;
});

const triggerCategorySidemenuSubItemEffect = (): void => {
  router.push(categoryItemListRoute);
  emit('effect');
};

watch(
  (): boolean => {
    return isActive.value;
  },
  (): void => {
    if (isActive.value) {
      emit('effect');
    }
  },
);

watch(
  (): Array<number | null> => {
    return [locationStore.getMainCategory, locationStore.getSubCategory];
  },
  (): void => {
    const matchMainCategory: boolean = props.mainCategory === locationStore.getMainCategory;
    const matchSubCategory: boolean = props.subCategory === locationStore.getSubCategory;

    itemListActiveRoute.value = matchMainCategory && matchSubCategory;
  },
  { immediate: process.env.NODE_ENV === 'test' },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("button", {
      class: _normalizeClass({
        'flex w-full rounded-sm border py-3 px-6': true,
        'button-inactive-state': !_unref(isActive),
        'border-lighten button-active-state': _unref(isActive),
      }),
      onClick: triggerCategorySidemenuSubItemEffect
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1)
    ], 2)
  ]))
}
}

})